import { api, unwrapData } from '../../../app/store/api';
import { ApiResponse, PaginatedResponse } from '../../../types';
import { BankAccountType } from '../types/bank.types';

export const bankApi = api.injectEndpoints({
    endpoints: (build) => ({
        add: build.mutation<BankAccountType, BankAccountType>({
            transformResponse: unwrapData,
            query: (data) => ({
                url: 'user/bank-accounts',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Banks' }] : []),
        }),

        update: build.mutation<BankAccountType, BankAccountType>({
            transformResponse: unwrapData,
            query: ({ id, ...body }) => ({
                url: `user/bank-accounts/${id}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Banks' }] : []),
        }),

        remove: build.mutation<null, BankAccountType['id']>({
            transformResponse: unwrapData,
            query: (id) => ({
                url: `user/bank-accounts/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Banks' }],
        }),

        accounts: build.query<
            PaginatedResponse<BankAccountType>,
            { page?: number; perPage?: number; search?: object; includeRemovedId?: number }
        >({
            transformResponse: unwrapData,
            query: ({ search, page, perPage = 15, includeRemovedId }) => ({
                url: 'user/bank-accounts',
                method: 'GET',
                params: {
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                    ...(includeRemovedId ? { include_removed_id: includeRemovedId } : {}),
                    ...search,
                },
            }),
            providesTags: ['Banks'],
        }),

        getBankList: build.query<BankAccountType[], void>({
            transformResponse: unwrapData,
            query: () => ({
                url: 'user/banks',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useRemoveMutation,
    useAccountsQuery,
    useUpdateMutation,
    useAddMutation,
    useGetBankListQuery,
} = bankApi;
